import axios from "axios";

const BASEURL = process.env.REACT_APP_BASEURL;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Anything except 2XX goes to here
    const status = error.response?.status || 500;
    if (status === 401 && window.location.pathname !== "/login") {
      window.location =
        window.location.protocol + "//" + window.location.host + "/login";
      localStorage.removeItem("token");
    } else {
      return Promise.reject(error); // Delegate error to calling side
    }
  }
);

//Locations
export async function getLocations(token, body = {}) {
  try {
    const response = await axios.get(
      BASEURL + "/locations",
      {
        headers: {
          Authorization: "Bearer " + token,
        },
        params: body,
      }
    );
    return response.data;
  } catch (e) {
    if (e) throw new Error(e);
  }
}

export async function getLocation(token, id) {
  try {
    const response = await axios.get(
      BASEURL + "/locations/" + id,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    return response.data;
  } catch (e) {
    if (e) throw new Error(e);
  }
}

export async function createLocation(token, data) {
  try {
    const response = await axios.post(
      BASEURL + "/locations",
      data,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    return response.data.data;
  } catch (e) {
    if (e) throw new Error(e);
  }
}

export async function deleteLocation(token, id) {
  try {
    const response = await axios.delete(
      BASEURL + "/locations/" + id,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    return response.data.data;
  } catch (e) {
    if (e) throw new Error(e);
  }
}

//Pois
export async function createPoi(token, locationId) {
  try {
    const response = await axios.post(
      BASEURL + "/locations/" + locationId + "/pois",
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    return response.data.data;
  } catch (e) {
    if (e) throw new Error(e);
  }
}

export async function deletePoi(token, id) {
  try {
    const response = await axios.delete(
      BASEURL + "/pois/" + id,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    return response.data;
  } catch (e) {
    if (e) throw new Error(e);
  }
}

export async function addAttachmentPoi(token, data, poiId) {
  try {
    const response = await axios.post(
      BASEURL + "/locations/pois/" + poiId + "/attachments",
      data,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    return response.data.data;
  } catch (e) {
    if (e) throw new Error(e);
  }
}

export async function addTextAttachmentPoi(token, data, poiId) {
  try {
    const response = await axios.post(
      BASEURL + "/locations/pois/" + poiId + "/text-attachment",
      data,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    return response.data.data;
  } catch (e) {
    if (e) throw new Error(e);
  }
}